import { useState } from "react";
import { Button, Modal, Stack } from "react-bootstrap";
import { Input, PasswordInput, PinInput } from "rsuite";

export default function SettingsTwoFactorDisableModal({ show, onClose, onComplete }) {
    const [password, setPassword] = useState("");
    const [backupCode, setBackupCode] = useState("");
    const [backupCodeMode, setBackupCodeMode] = useState(false);

    const handleComplete = async code => {
        await onComplete(password, code);
    };

    return (
        <Modal show={show} onHide={onClose} centered size="auto">
            <Modal.Header closeButton>
                <Modal.Title>Disable Two-Factor Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack gap={4}>
                    <Stack gap={3}>
                        <span>Enter Password</span>
                        <PasswordInput value={password} onChange={setPassword} placeholder="Password" />
                    </Stack>
                    <span className="text-center fs-6">AND</span>
                    {backupCodeMode ? (
                        <Stack gap={2} className=" align-items-center">
                            <span className=" align-self-start">Enter backup code</span>
                            <Stack direction="horizontal" gap={2}>
                                <Input size="lg" value={backupCode} onChange={setBackupCode} placeholder="Backup Code" />
                                <Button
                                    variant="ra-yellow"
                                    className="h-100 text-uppercase fw-bold text-nowrap"
                                    disabled={!password || !backupCode}
                                    onClick={async () => await handleComplete(backupCode)}>
                                    Disable 2FA
                                </Button>
                            </Stack>
                            <Button variant="ra-dark-blue-outline" size="sm" onClick={() => setBackupCodeMode(false)}>
                                Found the authenticator app again?
                            </Button>
                        </Stack>
                    ) : (
                        <Stack gap={2} className=" align-items-center">
                            <span>Enter 6-digit code from your authenticator app</span>
                            <PinInput size="lg" length={6} otp onComplete={handleComplete} disabled={!password} />
                            <Button variant="ra-dark-blue-outline" size="sm" onClick={() => setBackupCodeMode(true)}>
                                Lost Access to the authenticator app?
                            </Button>
                        </Stack>
                    )}
                    <p className="text-center fs-6 mb-0">You will be logged out from all devices</p>
                </Stack>
            </Modal.Body>
        </Modal>
    );
}
